module.exports = __webpack_public_path__ + "img/role-p-1.7fde4b43.png";